export default __webpack_public_path__ + "static/media/itau-logo.7fe2e58e.png";